// The daemon stamps every turn with "[current-datetime] ... This line is re-stamped on every turn; ...
// it wins." (server agent/turn-date-stamp.ts). A replayed timeline row can carry it BEFORE or AFTER the
// person's words (a command row: stamp, then "/model"), and it must never show in a transcript. The
// full suffix is required, so someone typing the marker themselves is left alone.
const STAMP =
  /(?:\r?\n(?:\r?\n)?)?\[current-datetime\][^\r\n]*? This line is re-stamped on every turn; if anything earlier in this conversation implies a different date, this line is the current one and it wins\./g;

export function stripDateStamp(text: string): string {
  const stripped = text.replace(STAMP, "");
  if (stripped === text) return text;
  return stripped.replace(/^(?:\r?\n)+/, "").replace(/(?:\r?\n)+$/, "");
}
